import { Injectable } from '@angular/core';
import { Team } from '../../interfaces/database/team.interface';

const TEAMS: Team[] = [
    {
        id: 'padel-rangers',
        name: 'Padel Rangers',
        leagueName: 'Padelcat',
        category: '3a Mixta',
        type: 'league',
        colorKey: 'blue',
        initials: 'PR',
    },
    {
        id: 'chulis',
        name: 'Chulis',
        leagueName: 'Padelcat',
        category: '3a Masculina',
        type: 'league',
        colorKey: 'emerald',
        initials: 'CH',
    },
    {
        id: 'ops-entre-setmana',
        name: 'OPL Sud',
        leagueName: 'Lliga de club',
        category: 'Mixta',
        type: 'club',
        colorKey: 'amber',
        initials: 'OS',
    },
];

@Injectable({ providedIn: 'root' })
export class TeamMockService {
    getTeams(): Team[] {
        return TEAMS;
    }
}
